import { render, staticRenderFns } from "./registerList.vue?vue&type=template&id=2a2c99fa&"
import script from "./registerList.vue?vue&type=script&lang=js&"
export * from "./registerList.vue?vue&type=script&lang=js&"
import style0 from "./registerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports